import { Component, OnInit, Input, DoCheck, Optional, NgZone, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { HtmlEditorOptions } from '../../Shared/Models/HtmlEditorOptions';

@Component({
  selector: 'BBSF-HtmlEditor',
  templateUrl: './HtmlEditor.component.html',
  styleUrls: ['./HtmlEditor.component.scss']
})
export class HtmlEditorComponent implements OnInit {


  static controlContainerstatic = null;
  constructor(private zone: NgZone, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public HtmlEditorControlHost: FormGroupDirective) {
    HtmlEditorComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: HtmlEditorOptions;
  @Output() OnChange = new EventEmitter();

  HtmlEditorFormControl: AbstractControl;
  WordCount: number = 0;
  WordCountArray: number = 0;
  markAllAsTouched: boolean = false;
  Config: any
  miscList: any
  styleList: any
  fontsizeList: any
  paraList: any
  insertList: any
  validationRules = [];
  validationRulesasync = [];

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.miscList = this.options.ToolsList_Misc != null ? this.options.ToolsList_Misc : ['codeview', 'undo', 'redo'];
    this.styleList = this.options.ToolsList_Style != null ? this.options.ToolsList_Style : ['bold', 'italic', 'underline', 'clear']
    this.fontsizeList = this.options.ToolsList_FontSize != null ? this.options.ToolsList_FontSize : ['fontname', 'fontsize', 'color']
    this.paraList = this.options.ToolsList_Para != null ? this.options.ToolsList_Para : ['style', 'ul', 'ol', 'paragraph', 'height']
    this.insertList = this.options.ToolsList_Insert != null ? this.options.ToolsList_Insert : ['table', 'picture', 'link', 'video', 'hr']

    this.Config = {
      callbacks: {
        // onChange: (e) => {

        //     this.zone.run(() => {
        //         this.onTextChange();
        //     });
        // },
        // onKeyup: (e) => {
        //     this.zone.run(() => {
        //         debugger;
        //         this.onTextChange();
        //     });
        // },
        // onKeydown: (e) => {
        //     this.zone.run(() => {
        //         debugger;
        //         if (this.WordCountArray > this.options.MaxWordCount && e.keyCode != 8) {
        //             e.preventDefault();
        //         }

        //     });
        // }
      },
      placeholder: this.options.Placeholder,
      height: `${this.options.Height}px`,
      toolbar: [
        ['misc', this.miscList],
        ['style', this.styleList],
        ['fontsize', this.fontsizeList],
        ['para', this.paraList],
        ['insert', this.insertList]
      ],
      fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']

    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.HtmlEditorFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);



    if (this.options.MinLength > 0) {
      this.validationRules.push(Validators.minLength(this.options.MinLength));
    }
    if (this.options.MaxLength > 0) {
      this.validationRules.push(Validators.maxLength(this.options.MaxLength));
    }
    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.HtmlEditorFormControl.setValidators(this.validationRules);
    this.HtmlEditorFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.HtmlEditorFormControl.disable();
    }

    this.HtmlEditorControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }


  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }
  onValueChanged() {
    this.OnChange.emit(this.HtmlEditorFormControl.value)
  }


  //External Method

  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.HtmlEditorFormControl, this.validationRules, this.options)
  }
  //External Method

  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.HtmlEditorFormControl, this.validationRules, this.options)
  }


  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.HtmlEditorFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.HtmlEditorFormControl, this.validationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.HtmlEditorFormControl)
  }

}


